import { useState, useEffect } from 'react';

const BASE_COUNT = 342;
const INCREMENT_MIN = 1;
const INCREMENT_MAX = 3;
const INTERVAL_MS = 8000;

export default function LiveSignupCounter() {
  const [count, setCount] = useState(BASE_COUNT);
  const [pulse, setPulse] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      const increment = Math.floor(Math.random() * (INCREMENT_MAX - INCREMENT_MIN + 1)) + INCREMENT_MIN;
      setCount((prev) => prev + increment);
      setPulse(true);
      setTimeout(() => setPulse(false), 600);
    }, INTERVAL_MS);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="inline-flex items-center gap-3 bg-white/5 border border-[#00FFD1]/20 rounded-full px-5 py-2.5 backdrop-blur-sm">
      {/* Live dot */}
      <span className="relative flex items-center justify-center w-2.5 h-2.5">
        <span className="absolute inline-flex h-full w-full rounded-full bg-[#00FFD1] opacity-75 animate-ping"></span>
        <span className="relative inline-flex rounded-full h-2 w-2 bg-[#00FFD1]"></span>
      </span>

      {/* Counter */}
      <span className="flex items-baseline gap-1.5">
        <span
          className={`text-xl font-bold tabular-nums transition-all duration-300 ${
            pulse ? 'text-[#00FFD1] scale-110' : 'text-white'
          }`}
          style={{ display: 'inline-block' }}
        >
          {count.toLocaleString()}
        </span>
        <span className="text-sm text-gray-300 font-medium">pilots on the waitlist</span>
      </span>

      {/* Icon */}
      <span className="w-4 h-4 flex items-center justify-center">
        <i className="ri-flight-takeoff-line text-[#00FFD1] text-sm"></i>
      </span>
    </div>
  );
}
